import React from "react";
import Button from "../../../../ui/Button";
import { CalendarIcon } from "../../../../utils/icon.utils";

export default function VehicleShowroomWorksDate({ data }) {
  return (
    <div className="text-end">
      <Button name={data} icon={CalendarIcon} />
    </div>
  );
}
